import { render, staticRenderFns } from "./PayrollView.vue?vue&type=template&id=2103aff6&"
import script from "./PayrollView.vue?vue&type=script&lang=js&"
export * from "./PayrollView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports